import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database"
const db = firebase.firestore();
const dbRef = firebase.database();

export const signInWithGoogle = async () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  const result = await firebase.auth().signInWithPopup(provider);
  const user = result.user;
  dbRef.ref(`userstatus/${user.uid}`).set("online")
  return user;
};

export const signInWithFacebook = async () => {
  const provider = new firebase.auth.FacebookAuthProvider();
  const result = await firebase.auth().signInWithPopup(provider);
  const user = result.user;
  dbRef.ref(`userstatus/${user.uid}`).set("online")
  return user;
};

export const createUser = async (user) => {
  const data = {
    displayName: user.displayName,
    email: user.email,
    photoURL: user.photoURL,
    emailVerified: user.emailVerified,
    phoneNumber: user.phoneNumber,
    isAnonymous: user.isAnonymous,
    uid: user.uid,
    metadata: {
      providerId: user.providerData[0].providerId,
      lastSignInTime: user.metadata.lastSignInTime,
      creationTime: user.metadata.creationTime

    }

  };
  await db.collection("users").doc(user.uid).set(data);
};

